/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-02-21, 09:54:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-02-22, 14:12:13
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  brandTheme: null,
  brandLogos: {
    main: null,
    panel: null,
    panel_hover: null,
    mobile: null,
  },
  brandId: null,
  isError: false,
};

const getters = {
  brandTheme: state => state.brandTheme,
  brandLogos: state => state.brandLogos,
  brandId: state => state.brandId,
  isError: state => state.isError,
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;



// WEBPACK FOOTER //
// ./src/store/modules/Brand/index.js